import axios from '../axios';
import * as axios2 from 'axios';
import * as apiTypes from "../constants/ApiConstants";
import moment from "moment";

/**
 *
 * @param type: 'EC' | 'CC'
 * @returns Promise<{merchant_id, access_token, paymetric_xi_url}>
 */
export function getPaymentAccessToken(type) {
  if (!(type === 'EC' || type === 'CC')) {
    return Promise.reject({error: "Invalid payment type."});
  }
  return axios.post(apiTypes.GET_PAYMENT_ACCESS_TOKEN, {
    action: '01',
    payment_method: type
  }).then(response => {
    return response.data;
  });
}

export function buildCCRequest(card_details, merchant_id, access_token) {
  let data = window.$XIPlugin.createJSRequestPacket(merchant_id, access_token);
  data.addField(window.$XIPlugin.createField('PAYMET', false, 'CC'));
  data.addField(window.$XIPlugin.createField('CCINS', false, card_details.card_type));
  data.addField(window.$XIPlugin.createField('CCNUM', true, card_details.card_number.replace(/\s/g, '')));
  data.addField(window.$XIPlugin.createField('CCNAME', false, card_details.card_name));
  data.addField(window.$XIPlugin.createField('VALTM', false, parseInt(card_details.card_month, 10)));
  data.addField(window.$XIPlugin.createField('VALTY', false, parseInt(card_details.card_year, 10)));
  data.addField(window.$XIPlugin.createField('CVVAL', false, card_details.card_validation_code));
  return data;
}

export function buildECRequest(ec_details, merchant_id, access_token) {
  let data = window.$XIPlugin.createJSRequestPacket(merchant_id, access_token);
  data.addField(window.$XIPlugin.createField('PAYMET', false, 'EC'));
  data.addField(window.$XIPlugin.createField('CCINS', false, 'EC'));
  data.addField(window.$XIPlugin.createField('CCNUM', true, ec_details.account_number.replace(/\s/g, '').replace(/-/g, '').padStart(10, "0")));
  data.addField(window.$XIPlugin.createField('CCNAME', false, ec_details.name));
  data.addField(window.$XIPlugin.createField('ECRDFI', false, ec_details.routing_number));
  data.addField(window.$XIPlugin.createField('ECACTTYP', false, ec_details.type));
  return data;
}

const encodeForm = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

export function getPaymetricResponse(paymetricUrl, data) {
  return new Promise((resolve, reject) => {
    window.$XIPlugin.ajax({
      url: paymetricUrl + "/Ajax",
      type: "POST",
      data: data,
      success: function(a) {
        console.log(a);
        resolve(a);
      },
      error: function(a) {
        reject(a);
      }
    });
  });
  // return axios2.post(paymetricUrl + '/Ajax', encodeForm(data), {
  //   headers: {
  //     'Content-Type': 'application/x-www-form-urlencoded'
  //   }
  // }).then(response => {
  //   return response.data;
  // });
}

export function getPaymentResponse(access_token) {
  return axios.post(apiTypes.GET_PAYMENT_RESPONSE, {
    action: '02',
    access_token: access_token
  }).then(response => {
    return response.data;
  });
}

export function addPaymentMethod(customer_number, company_code, payment_card, make_default = false, cvv = "") {
  let action = '01';
  return sendManagePaymentCardsRequest(action, customer_number, company_code, payment_card, make_default, cvv);
}

export function updatePaymentMethod(customer_number, company_code, payment_card, make_default = false) {
  let action = '02';
  return sendManagePaymentCardsRequest(action, customer_number, company_code, payment_card, make_default);
}

export function deletePaymentMethod(customer_number, company_code, payment_card, make_default = false) {
  let action = '03';
  return sendManagePaymentCardsRequest(action, customer_number, company_code, payment_card, make_default);
}


export function preAuthCCPaymentMethod(customer_number, company_code, payment_card, make_default = false, cvv = "") {
  let action = '04';
  return sendManagePaymentCardsRequest(action, customer_number, company_code, payment_card, make_default, cvv);
}

function sendManagePaymentCardsRequest(action, customer_number, company_code, payment_cards, make_default, cvv = "") {
  return axios.post(apiTypes.MANAGE_PAYMENTS_URL, {
    payer_data: {
      customer_number: customer_number,
      company_code: company_code,
    },
    action: action,
    payment_cards: [{
      payment_card_name: payment_cards.payment_card_name,
      payment_card_token: payment_cards.payment_card_token,
      payment_card_type: payment_cards.payment_card_type,
      valid_from: "",
      valid_to: payment_cards.valid_to,
      default: make_default ? 'X' : '',
      card_validation_code: cvv,
      electronic_check_account_type: payment_cards.electronic_check_account_type,
      electronic_check_rdfi_number: payment_cards.electronic_check_rdfi_number,
    }]
  }).then(response => {
    if (response.data && response.data.message_type === "S") {
      return response.data;
    } else if (response.data && response.data.status && response.data.status.message_type === "S") {
      return response.data;
    } else {
      throw {message_number: response.data.message_number, message_string: response.data.message_line_string};
    }
  });
}

export function cardFormToUpdateObject(card, token) {
  let valid_to = moment();
  valid_to.year(card.card_year);
  valid_to.month(parseInt(card.card_month) - 1);
  valid_to.endOf('month');
  return {
    payment_card_name: card.card_name,
    payment_card_token: token,
    payment_card_type: card.card_type,
    valid_from: "",
    valid_to: valid_to.format('MM-DD-YYYY'),
    card_validation_code: card.card_validation_code,
    electronic_check_account_type: card.electronic_check_account_type,
    electronic_check_rdfi_number: card.electronic_check_rdfi_number,
  }
}

export function checkFormToUpdateObject(card, token) {
  return {
    payment_card_name: card.name,
    payment_card_token: token,
    payer_account: card.payer_account,
    payment_card_type: "EC",
  }
}
